import { connect } from 'react-redux';
import OxxoPaymentInfo from './OxxoPaymentInfo';

const mapStateToProps = ({ purchase, payment }) => ({
  amount: purchase.get('total'),
  paydayLimit: payment.get('expirationDate'),
  pdfUrl: payment.get('paymentFormatUrl'),
  reference: payment.get('reference'),
});

export default connect(mapStateToProps)(OxxoPaymentInfo);
